import groupBy from 'lodash/groupBy';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import { User } from 'api/models';
import { selectUsersList } from 'data/members/slice';

/**
 *
 * @deprecated Use `UsersStore` to look up by company id
 */
export const useMembersByCompanies = (companyIdList: number[]) => {
  const projectMembersStoreData = useSelector(selectUsersList);
  let filteredUsers: User[] | [] = [];

  if (isArray(companyIdList) && !isEmpty(companyIdList)) {
    filteredUsers = projectMembersStoreData?.filter((member) =>
      companyIdList.includes(member?.company?.companyId),
    );
  }

  return groupBy(filteredUsers, 'company.companyId');
};
